import React from "react";
import { Grid, Paper, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";

const About = () => {
    const paragraphText = {
        fontWeight: "normal",
        margin: {
            xs: "0 0 30px",
            sm: "0 40px 20px",
        },
        fontSize: {
            xs: "16px",
            sm: "22px",
        },
        textAlign: "justify",
    };

    const aboutBox = {
        display: "flex",
        mx: {
            xs: 2,
            sm: 8,
        },
    };

    return (
        <a id="about">
            <Box sx={{ p: 1, pt: 10 }}>
                <Typography
                    variant="h3"
                    sx={{
                        color: "#5ce2e2",
                        mt: 3,
                        mb:3,
                        fontWeight: "bold",
                        textShadow:
                            "1px 1px 1px #919191, 1px 2px 1px #919191,1px 3px 1px #919191",
                    }}
                >
                    About Kat Oltmans
                </Typography>
                <Box sx={aboutBox}>
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={10}>
                        <Box sx={{ maxWidth: "200px", py: 1, m: "auto" }}>
                            <img
                                src="/imgs/unaskedPic.jpg"
                                alt="Kat Oltmans profile picture"
                            />
                        </Box>

                        <Stack direction="column" spacing={3}>
                            <Box>
                                <Typography variant="h6" sx={paragraphText}>
                                   I am a software and platform engineer with experience designing and delivering internal applications, system integrations, workflow automation, and operational tooling across enterprise environments. My work focuses on building reliable, maintainable solutions that improve efficiency, visibility, and user experience for the teams and end users who depend on them.
                                </Typography>
                                <Typography
                                    variant="h6"
                                    sx={paragraphText}
                                    style={{
                                        whiteSpace: "pre-wrap",
                                    }}
                                >
                                    In my current role, I design and implement application features, integrations, and automation across platforms including ServiceNow, monitoring systems, and analytics tooling. I have led platform upgrades, developed workflow enhancements that support internal operational workflows, built reporting and validation tools, and helped deliver large-scale platform changes such as enterprise monitoring migrations. I also established structured User Acceptance Testing (UAT) and release practices to support safe, predictable delivery to production environments.
                                </Typography>
                                <Typography
                                    variant="h6"
                                    sx={paragraphText}
                                    style={{ whiteSpace: "pre-wrap" }}
                                >
                                    Before transitioning into engineering, I worked in education, where I gained firsthand experience with digital learning workflows, student engagement, and virtual instruction. During the shift to remote learning, I designed and delivered a fully online classroom experience using Schoology, building digital workflows that supported accessibility, continuity, and student progress. While that work was rooted in instructional technology rather than traditional software development, it gave me early experience designing learning systems and an appreciation for developing software that is practical, reliable, and genuinely useful.
                                </Typography>
                                <Typography
                                    variant="h6"
                                    sx={paragraphText}
                                    style={{ whiteSpace: "pre-wrap" }}
                                >
                                   With experience as both an educator and an engineer, I am especially motivated by opportunities to contribute to learning systems that support students, educators, and families. I care deeply about building software that is thoughtful, maintainable, and capable of making a meaningful difference in how people learn and work.
                                </Typography>
                            </Box>
                        </Stack>
                    </Stack>
                </Box>
                {/* <Grid container>
                    <Grid item xs={6} sx={{ p: 5 }}>
                        <Paper elevation={2} sx={{ mx: 38, p: 1 }}>
                            <img
                                src="/imgs/ProfilePic.jpg"
                                alt="profile picture"
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={6} sx={{ p: 5 }}></Grid>
                </Grid> */}
            </Box>
        </a>
    );
};

export default About;
